import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'

import { listChecklistResults, listChecklists, setChecklistResultsField } from '../actions/checklist'

import ChecklistResults from '../components/ChecklistResults'

class ChecklistResultsPage extends Component {
  componentDidMount () {
    const { listChecklists } = this.props
    listChecklists({ limit: -1 })
  }

  render () {
    return (<ChecklistResults {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const results = _.get(state, 'checklist.results', {})
  const list = _.get(state, 'checklist.list', {})
  return {
    list: results.list,
    checklists: list.rows || [],
    checklistId: results.checklistId,
    checkDate: results.checkDate || moment()
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  listChecklistResults (values, checkDate, csv = false) {
    if (values.checklistId && checkDate) {
      dispatch(listChecklistResults(values.checklistId, checkDate.format('YYYY-MM-DD'), csv))
    }
  },
  listChecklists (query) {
    dispatch(listChecklists(query))
  },
  onCheckDateChanged (value) {
    dispatch(setChecklistResultsField('checkDate', value ? value : undefined))
  },
  goBack () {
    dispatch(goBack())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistResultsPage)


// WEBPACK FOOTER //
// ./src/containers/ChecklistResultsPage.js